export function RequireAuth({ children }: { children: JSX.Element }) {
  return children;
}
export enum StorageKeys {
  RECIPIENT_VOUCHERS = "RECIPIENT_VOUCHERS",
  DOWNLOAD_VOUCHERS = "DOWNLOAD_VOUCHERS",
}
